import { render, staticRenderFns } from "./commonH5.vue?vue&type=template&id=1cca3df8&scoped=true"
import script from "./commonH5.vue?vue&type=script&lang=js"
export * from "./commonH5.vue?vue&type=script&lang=js"
import style0 from "./commonH5.vue?vue&type=style&index=0&id=1cca3df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cca3df8",
  null
  
)

export default component.exports